﻿import { projectSettings } from "../../config";

import LandingPage from "./LandingPage.svelte";
import PersonalDetails from "./PersonalDetails.svelte";
import ClaimDetails from "./ClaimDetails.svelte";


const confirmationPages = [
    {
        component: LandingPage,
        routeId: `${projectSettings.basePath}Registration`,
        confirmationHeading: null,
    },
    {
        component: PersonalDetails,
        routeId: `${projectSettings.basePath}Registration/PersonalDetails`,
        confirmationHeading: "Your details",
    },
    {
        component: ClaimDetails,
        routeId: `${projectSettings.basePath}Registration/ClaimDetails`,
        confirmationHeading: "Claim details",
    },
];

export default confirmationPages;

